import config from 'SRC/config/config.yaml'

export const globalOptions = config.globalOptions
